import { useMenuState } from '@app/src/hooks/mui-hooks'
import { ArrowDropDown, AutoAwesomeOutlined } from '@mui/icons-material'
import { Button, ButtonGroup, ListItemText, Menu, MenuItem } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'

export type AiAction = {
  labelId: string
  onClick: () => void
  disabled?: boolean
}

type AiActionsDropdownProps = {
  actions: AiAction[]
  disabled?: boolean
}

const AiActionsDropdown: React.FC<AiActionsDropdownProps> = ({ actions, disabled }) => {
  const { formatMessage } = useIntl()
  const [isMenuOpen, menuAnchorElement, openMenu, closeMenu] = useMenuState()

  const handleActionClick = (action: AiAction) => {
    closeMenu()
    action.onClick()
  }

  const isDisabled = disabled || (actions.length > 0 && actions.every(action => action.disabled))

  const buttonStyles = {
    backgroundColor: 'communication.light',
    borderColor: 'communication.main',
    color: 'communication.dark',
    '&:hover': {
      backgroundColor: 'communication.light',
      borderColor: 'communication.main',
      cursor: 'pointer',
    },
  }

  return (
    <>
      <ButtonGroup
        size="small"
        disabled={isDisabled}
        sx={{
          borderRadius: 5,
          '& .MuiButtonGroup-grouped': {
            ...buttonStyles,
            '&:not(:last-of-type)': {
              borderRightColor: 'communication.main',
            },
          },
          '& .MuiButtonGroup-firstButton': {
            borderTopLeftRadius: 20,
            borderBottomLeftRadius: 20,
          },
          '& .MuiButtonGroup-lastButton': {
            borderTopRightRadius: 20,
            borderBottomRightRadius: 20,
          },
        }}
      >
        <Button
          onClick={openMenu}
          startIcon={<AutoAwesomeOutlined sx={{ fontSize: 18, color: 'communication.dark' }} />}
          sx={{ textTransform: 'none', pl: 2 }}
        >
          {formatMessage({ id: 'general.ai' })}
        </Button>
        <Button size="small" onClick={openMenu} sx={{ px: 0.5, minWidth: 'auto' }}>
          <ArrowDropDown />
        </Button>
      </ButtonGroup>
      <Menu
        anchorEl={menuAnchorElement}
        open={isMenuOpen}
        onClose={closeMenu}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      >
        {actions.map(action => (
          <MenuItem key={action.labelId} onClick={() => handleActionClick(action)} disabled={action.disabled}>
            <ListItemText>{formatMessage({ id: action.labelId })}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}

export default AiActionsDropdown
